module.exports = __webpack_public_path__ + "media/images/media/media4-78c3dae648dc045f5489d8b270a7910c.jpg";